import { useState } from 'react';

const faqs = [
  {
    question: '发酵黄油和普通黄油有什么区别？',
    answer: '发酵黄油是在制作过程中加入了乳酸菌进行发酵，因此带有独特的坚果香气和微微的酸味，口感更加丰富细腻。普通黄油则没有经过发酵，奶味更纯粹直接。在烘焙中，发酵黄油能让成品香气更复杂、层次更丰富，特别适合做法式甜点和可颂。',
  },
  {
    question: '家用烘焙应该选有盐还是无盐黄油？',
    answer: '强烈推荐选择<strong>无盐黄油</strong>。因为不同品牌有盐黄油的含盐量差异很大，烘焙配方中的盐量需要精确控制。使用无盐黄油可以让你完全掌控成品的咸度，避免过咸。有盐黄油更适合直接涂抹面包食用。',
  },
  {
    question: '进口黄油一定比国产黄油好吗？',
    answer: '不一定。进口黄油在某些品类（如发酵黄油）确实有传统优势，但国产黄油近年品质提升很快。选择黄油应该看具体用途：做可颂推荐法国发酵黄油，日常家庭烘焙用安佳、总统等性价比就很好。关键是根据自己的需求和预算来选择。',
  },
  {
    question: '黄油打开后能保存多久？',
    answer: '无盐黄油开封后在冰箱冷藏可保存2-3周，有盐黄油因盐的防腐作用可保存3-4周。如果需要长期保存，可以将黄油切成小块用保鲜膜包好放入冷冻室，可保存6-9个月。注意要用密封容器存放，避免吸收冰箱异味。',
  },
  {
    question: '如何判断一款黄油好不好？',
    answer: '可以从以下几个方面判断：（1）颜色：优质黄油呈均匀的淡黄色；（2）气味：应有纯净的奶香，无异味；（3）口感：入口即化，细腻顺滑；（4）乳脂含量：一般82%以上为佳；（5）看配料表：成分越简单越好，优质黄油只含稀奶油和发酵菌种。',
  },
  {
    question: '做可颂必须用起酥黄油吗？',
    answer: '做可颂强烈建议使用专门的起酥黄油（也叫片状黄油）。起酥黄油比普通黄油的熔点更高、延展性更好，在反复折叠擀制过程中不易融化渗入面团，能形成更完美的层次。法国伊斯尼和铁塔的起酥黄油是做可颂的首选。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer.replace(/<[^>]*>/g, ''),
      },
    })),
  };

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
            常见问题解答
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            关于黄油的常见疑问，这里都有答案
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-lg overflow-hidden"
            >
              <button
                type="button"
                onClick={() => toggleFaq(index)}
                className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
              >
                <span className="text-sm md:text-base font-medium text-foreground-800 pr-8">
                  {faq.question}
                </span>
                <span
                  className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${
                    openIndex === index ? 'rotate-45' : ''
                  }`}
                >
                  <i className="ri-add-line text-foreground-500 text-lg"></i>
                </span>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-5 pb-4">
                  <p
                    className="text-sm text-foreground-600 leading-relaxed"
                    dangerouslySetInnerHTML={{ __html: faq.answer }}
                  ></p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}